
function Temp (value) {
    const kelvin = 273.15;
    return Math.round(value - kelvin)
}

export default Temp;